import propTypes from 'prop-types';
import { useMemo } from 'react';
import * as UI from '..';
import * as S from './styles';

const SideMenu = ({
  title,
  list,
  loading,
  itemSelected,
  changeSelectedItem,
}) => {
  const visibleMenuItems = useMemo(() => list.filter(item => item.show), [
    list,
  ]);

  const hasChildSelected = item =>
    item.children?.some(child => child.value === itemSelected);

  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      <S.ListGroup flexDirection="column" px={loading && '16px'}>
        {!list.length && loading ? (
          <UI.PlaceHolder type="line" lines={5} />
        ) : (
          visibleMenuItems.map(item => {
            const visibleChildren = item.children?.filter(c => c.show) ?? [];
            const parentActive =
              itemSelected === item.value || hasChildSelected(item);

            return (
              <S.ListGroup key={item.id} flexDirection="column">
                <S.ListGroupItem
                  active={parentActive}
                  onClick={() => changeSelectedItem(item.value)}
                >
                  {item.description}
                </S.ListGroupItem>
                {visibleChildren.map(child => (
                  <S.SubListGroupItem
                    key={child.id}
                    active={itemSelected === child.value}
                    onClick={() => changeSelectedItem(child.value)}
                  >
                    {child.description}
                  </S.SubListGroupItem>
                ))}
              </S.ListGroup>
            );
          })
        )}
      </S.ListGroup>
    </S.Container>
  );
};

export default SideMenu;

const menuItemShape = propTypes.shape({
  id: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  show: propTypes.bool.isRequired,
});

SideMenu.propTypes = {
  title: propTypes.string.isRequired,
  list: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.string.isRequired,
      description: propTypes.string.isRequired,
      value: propTypes.string.isRequired,
      show: propTypes.bool.isRequired,
      children: propTypes.arrayOf(menuItemShape),
    }),
  ),
  itemSelected: propTypes.oneOfType([propTypes.string, propTypes.number]),
  changeSelectedItem: propTypes.func.isRequired,
  loading: propTypes.bool.isRequired,
};

SideMenu.defaultProps = {
  list: [],
  itemSelected: null,
};
